import styled from 'styled-components';

import {
  flexbox,
  alignItems,
  justifyContent
} from '../../../styles/helpers/flexbox';

export const ModalWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
        ${flexbox()};
        ${alignItems('center')};
        ${justifyContent('center')};

        background: white;
        position: absolute;
        left: -47px;
        top: -20px;
        z-index: 99;
        overflow: hidden
        width: 100px;
        height: 20px;
        border: 2px solid ${colours.grey[400]};
`;
});

export const ContentTheme = styled.div((props) => {
  const { colours } = props.theme;

  return `
    color: ${colours.grey[600]};
  `;
});



// WEBPACK FOOTER //
// ./components/line-chart/hover-context/hover-context.styled.js